// libs
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

// constants/ interfaces
import { IActiveFilter } from 'src/interfaces/filters'

// helpers
import { setActiveFilter } from 'src/actions/filters/filters'
import { AppDispatch } from 'src/actions/app-state/app-state'

export const useSetActiveFilter = () => {
  const dispatch = useDispatch<AppDispatch>()
  return useCallback((filter: IActiveFilter) => {
    dispatch(setActiveFilter(filter))
  }, [dispatch])
}
